import { Row } from 'basic-ui-lib/components/Box';
import colors from 'basic-ui-lib/constants/colors';
import styled from 'styled-components';
import { renderMedia } from '../MainZone';
import { IContentItem } from 'modules/channel/interfaces/api';

interface ThreeZoneProps {
  value?: IContentItem[];
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
  gap?: number;
}
const ThreeZone = ({ value, activeZone, onSelectZone, gap, border }: ThreeZoneProps) => {
  const zoneValue = value?.find(item => item.zone === 'MAIN');
  const zone01Value = value?.find(item => item.zone === 'RIGHT');
  const zone02Value = value?.find(item => item.zone === 'BOTTOM');

  return (
    <ThreeZoneIllustration $border={border} $gap={gap}>
      <Row width='100%' height='88%' gap={gap ? `${gap}px` : '1px'}>
        <MainZone $border={border} $active={activeZone === 'MAIN'} onClick={() => onSelectZone?.('MAIN')}>
          {renderMedia(zoneValue, border)}
        </MainZone>
        <Zone01 $border={border} $active={activeZone === 'RIGHT'} onClick={() => onSelectZone?.('RIGHT')}>
          {renderMedia(zone01Value, border)}
        </Zone01>
      </Row>
      <Zone02 $border={border} $active={activeZone === 'BOTTOM'} onClick={() => onSelectZone?.('BOTTOM')}>
        {renderMedia(zone02Value, border)}
      </Zone02>
    </ThreeZoneIllustration>
  );
};

export default ThreeZone;

const ThreeZoneIllustration = styled.div<{ $border?: number; $gap?: number }>`
  width: 100%;
  height: 100%;
  min-width: 48px;
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  background-color: ${colors.neutral.text[3]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: ${({ $gap }) => ($gap ? `${$gap}px` : '1px')};
`;

const MainZone = styled.div<{ $border?: number; $active?: boolean }>`
  width: 75%;
  height: 100%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;

const Zone01 = styled.div<{ $border?: number; $active?: boolean }>`
  width: 25%;
  height: 100%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;
const Zone02 = styled.div<{ $border?: number; $active?: boolean }>`
  width: 100%;
  height: 12%;
  background-color: ${colors.neutral.text[2]};
  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};
  position: relative;
`;
